export const PROVIDER_JAWG = 'Jawg';
export const COUNTRY_LAYER_ONLY = 'country';
export const PLACE_LAYERS =
    'island,dependency,neighbourhood,locality,borough,localadmin,county,macrocounty,region,macroregion,country,postalcode,venue';
// Placeholder ids that must never reach the API as a polygon location_id.
export const SENTINEL_LOCATION_IDS = ['everywhere', 'local', 'bounds', 'false'];
